<template lang="pug">
  .container.grid-lg.py-2
    form.list-filters(@submit.prevent='listar')
      .columns.align-center
        .column
          .form-group.tooltip.tooltip-bottom(:data-tooltip="'legislacao.titulo' | tModel")
            input.input-sm.razao-social.form-input(type='search' v-model='q.titulo_cont' :placeholder="'legislacao.titulo' | tModel")
        .column.col-auto.text-right
          button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
            i.fa.fa-search.fa-lg
        .column.col-auto
          router-link.btn.btn-action.s-circle.tooltip.tooltip-bottom(
            :to="{name: 'app.sistema.legislacoes.new'}" 
            data-tooltip='Nova' 
            v-acl:allowed.admin.sistema.legislacoes.create
          )
            i.icon.icon-plus
    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        .columns
          .column.col-6.col-md-12(v-for='p in list' :key='p.id')
            .my-2
              list-item-card
                .h6 {{ p.titulo }}
                .columns.mt-2
                  .column
                    .tooltip.abbr(:data-tooltip="'legislacao.created_at' | tModel") {{ p.created_at | date }}
                  .column.text-right
                    .tooltip.abbr(:data-tooltip="'legislacao.updated_at' | tModel") {{ p.updated_at | date }}
                .text-right(slot='footer')
                  router-link.btn.btn-link.tooltip(
                    :to="{name: 'app.sistema.legislacoes.show', params: {id: p.id}}",
                    :data-tooltip="$i18n.t('views.buttons.show.label')"
                    v-acl:allowed.admin.sistema.legislacoes.show
                  )
                    btn-icon.fa-lg(name='show')
    .text-center(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
export default {
  vuex: {
    'sistema/legislacoes': {
      state: ['list', 'status', 'page', 'pages', 'query', 'count'],
      getters: ['loading'],
      mutations: ['setQuery', 'setPage'],
      actions: ['fetchList', 'prevPage', 'nextPage', 'goPage'],
    },
  },
  data() {
    return {
      q: {
        titulo_cont: '',
      },
    }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
